import CheckIcon from '@mui/icons-material/Check';
import Box from '@mui/material/Box';
import { motion } from 'framer-motion';
import { successCopy } from '@/Pages/Success/copy';
import { useSuccessAnimation } from '@/Pages/Success/hooks/useSuccessAnimation';
import '@/Pages/Success/SuccessPage.sass';

function SuccessIconContent(): JSX.Element {
  return <CheckIcon className="success-icon__check" aria-hidden="true" />;
}

export function SuccessIcon(): JSX.Element {
  const { reduceMotion, icon } = useSuccessAnimation();

  if (reduceMotion) {
    return (
      <Box
        className="success-icon"
        data-testid="success-icon"
        data-motion="reduced"
        role="img"
        aria-label={successCopy.iconAlt}
      >
        <SuccessIconContent />
      </Box>
    );
  }

  return (
    <Box
      component={motion.div}
      className="success-icon"
      data-testid="success-icon"
      data-motion="animated"
      role="img"
      aria-label={successCopy.iconAlt}
      initial={icon.initial}
      animate={icon.animate}
      transition={icon.transition}
    >
      <SuccessIconContent />
    </Box>
  );
}
